import { Component, input, output } from '@angular/core';
import { faClose } from '@fortawesome/pro-solid-svg-icons';

import { Option } from '../../../models/option.model';

@Component({
  selector: 'eiq-chip',
  templateUrl: 'chip.component.html',
  styleUrls: ['./chip.component.scss', './_chip-theme.component.scss']
})
export class ChipComponent {
  closeTooltip = input<string>('Remove');
  option = input<Option<unknown>>();
  testId = input<string>();

  remove = output<Option<unknown>>();

  faClose = faClose;
}
